const RENTAL_TYPES = {
  long_term_rental: 'Long Term Rental',
  short_term_rental: 'Short Term Rental',
};

export default RENTAL_TYPES;
